module.exports = __webpack_public_path__ + "2b85d39bf15727c72fed2feb2b496b2e.svg";